import cssMobile from '../../css/editorMobile.module.css'
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome'
import {faPlus} from '@fortawesome/free-solid-svg-icons'
import {useTranslation} from 'react-i18next'

interface AddPhotoProps {
  active: boolean
  openModal: () => void
}

export default function AddPhoto({active, openModal}: AddPhotoProps) {
  const {t} = useTranslation()
  return (
    <div className={`${cssMobile.tab} ${active ? cssMobile.active : ''}`}>
      <div className={cssMobile.action} onClick={openModal}>
        <FontAwesomeIcon icon={faPlus} />
        <span>{t('Hozzáadás')}</span>
      </div>
    </div>
  )
}
